/**
 * MO Proxy API - RXPROXY API for prescriptions
 * Migrated from src/alpine/utils/proxyApi.js (already uses fetch)
 */
(function () {
  "use strict";

  window.MO = window.MO || {};

  var PROXY_CONFIG = {
    BASE_URL: "https://rxproxy.ezvz.app/proxy",
    SHOP_DOMAIN: "m7at0e-wp.myshopify.com",
    SUBDOMAIN: "maskoptix",
    HMAC_SIGNATURE: "1f62c2fe92bbc12b38b425adbcc16c2979e5704848d5ef93ce16968c28937c2f"
  };

  function getProxyHeaders(contentType) {
    if (contentType === undefined) contentType = "application/json";
    var headers = {
      "X-Shopify-Hmac-SHA256": PROXY_CONFIG.HMAC_SIGNATURE
    };
    if (contentType) {
      headers["Content-Type"] = contentType;
    }
    return headers;
  }

  function normalizeResponse(response) {
    if (!response) {
      return { success: false, error: "No response received" };
    }
    if (response.success && response.data && typeof response.data === "object") {
      return Object.assign({ success: true }, response.data, { data: response.data });
    }
    return response;
  }

  async function makeProxyRequest(action, payload) {
    try {
      var response = await fetch(PROXY_CONFIG.BASE_URL, {
        method: "POST",
        headers: getProxyHeaders(),
        body: JSON.stringify(Object.assign({ action: action }, payload))
      });

      if (!response.ok) {
        var errorText = await response.text();
        throw new Error("HTTP " + response.status + ": " + errorText);
      }

      var data = await response.json();
      return normalizeResponse(data);
    } catch (error) {
      console.error("[RXPROXY] " + action + " failed:", error);
      return {
        success: false,
        error: error.message || "API request failed"
      };
    }
  }

  /**
   * Analyze prescription image using OCR
   */
  async function analyzePrescription(file) {
    if (!file) {
      return { success: false, error: "No file provided" };
    }

    try {
      var formData = new FormData();
      formData.append("action", "analyze-prescription");
      formData.append("shop_domain", PROXY_CONFIG.SHOP_DOMAIN);
      formData.append("prescription", file);

      var headers = getProxyHeaders(null);
      delete headers["Content-Type"];

      var response = await fetch(PROXY_CONFIG.BASE_URL, {
        method: "POST",
        headers: headers,
        body: formData
      });

      if (!response.ok) {
        var errorText = await response.text();
        throw new Error("HTTP " + response.status + ": " + errorText);
      }

      var data = await response.json();
      var responseData = data.data || data;
      var uniqueId = responseData.uniqueId || responseData.unique_id;

      if (!uniqueId) {
        console.warn("[RXPROXY] No uniqueId in analyze response");
      }

      return {
        success: data.success || responseData.success || true,
        prescriptionData: responseData.prescriptionData,
        uniqueId: uniqueId,
        analysis: responseData.analysis,
        data: responseData
      };
    } catch (error) {
      console.error("[RXPROXY] analyzePrescription error:", error);
      return {
        success: false,
        error: error.message || "Failed to analyze prescription"
      };
    }
  }

  /**
   * Save prescription data
   */
  async function savePrescription(params) {
    var orderId = params.orderId;
    var lineItemId = params.lineItemId;
    var prescriptionData = params.prescriptionData;

    if (!orderId || !lineItemId || !prescriptionData) {
      return {
        success: false,
        error: "Missing required parameters: orderId, lineItemId, or prescriptionData"
      };
    }

    try {
      var payload = Object.assign({
        action: "save-prescription",
        shop_domain: PROXY_CONFIG.SHOP_DOMAIN,
        order_id: orderId,
        line_item_id: lineItemId
      }, prescriptionData);

      var response = await fetch(PROXY_CONFIG.BASE_URL, {
        method: "POST",
        headers: getProxyHeaders(),
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        var errorText = await response.text();
        throw new Error("HTTP " + response.status + ": " + errorText);
      }

      var data = await response.json();
      var result = normalizeResponse(data);

      if (!result.success) return result;

      var rxUID = (result.data && result.data.rxUID) || result.rxUID;
      if (!rxUID) {
        console.warn("[RXPROXY] No rxUID in save response:", result);
      }

      return {
        success: true,
        data: Object.assign({ rxUID: rxUID }, result.data)
      };
    } catch (error) {
      console.error("[RXPROXY] savePrescription error:", error);
      return {
        success: false,
        error: error.message || "Failed to save prescription"
      };
    }
  }

  /**
   * Get order details
   */
  async function getOrder(orderId) {
    if (!orderId) {
      return { success: false, error: "No orderId provided" };
    }
    return makeProxyRequest("get-order", {
      shop_domain: PROXY_CONFIG.SHOP_DOMAIN,
      orderId: orderId
    });
  }

  /**
   * Get prescription file URL
   */
  async function getPrescriptionFile(uniqueId) {
    if (!uniqueId) {
      return { success: false, error: "No uniqueId provided" };
    }
    return makeProxyRequest("get-prescription-file", {
      shop_domain: PROXY_CONFIG.SHOP_DOMAIN,
      uniqueId: uniqueId
    });
  }

  /**
   * Update line item properties
   */
  async function updateLineItemProperties(params) {
    if (!params.orderId || !params.lineItemId || !params.properties) {
      return {
        success: false,
        error: "Missing required parameters: orderId, lineItemId, or properties"
      };
    }
    return makeProxyRequest("update-line-item-properties", {
      shop_domain: PROXY_CONFIG.SHOP_DOMAIN,
      orderId: params.orderId,
      lineItemId: params.lineItemId,
      properties: params.properties
    });
  }

  window.MO.proxyApi = {
    analyzePrescription: analyzePrescription,
    savePrescription: savePrescription,
    getOrder: getOrder,
    getPrescriptionFile: getPrescriptionFile,
    updateLineItemProperties: updateLineItemProperties,
    config: PROXY_CONFIG
  };
})();
